import React, { FC }                from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Icon }             from "semantic-ui-react";
import UpdateCustomerRecord         from "../../../../application/usecase/record/customer/UpdateCustomerRecord";
import CustomerId                   from "../../../../domain/customer/CustomerId";
import CustomerRecord               from "../../../../domain/record/customer/CustomerRecord";
import { ResKaState }               from "../../../../index";

const CustomerRecordUpdateButton: FC = () => {
  const customerId: CustomerId = useSelector((state: ResKaState) => state.customer.id);
  const customerRecord: CustomerRecord = useSelector((state: ResKaState) => state.customerRecord);
  const updateCustomerRecord: UpdateCustomerRecord = new UpdateCustomerRecord(useDispatch());
  return (
    <>
      <Button
        icon
        labelPosition="left"
        positive
        onClick={ () => updateCustomerRecord.execute(customerId, customerRecord) }
      >
        <Icon name="save"/>
        保存する
      </Button>
    </>
  );
};

export default CustomerRecordUpdateButton;
